// extracted by mini-css-extract-plugin
export default {"container":"Company_container__xx4Ra","cardContainer":"Company_cardContainer__1iVSi","headerText":"Company_headerText__tIxMF"};